import { field, validate } from '@balance-web/forms';

import {
  validateEmail,
  validatePassword,
  validatePhoneNumber,
} from '../../../utils/validations';

export const SingupFormSchema = field.object(
  {
    email: field.text({
      validate: validate(validateEmail),
    }),
    firstname: field.text({
      validate: validate((value) => {
        validate.required(value, 'First name');
        validate.minLength(value, 2);
        return value;
      }),
    }),
    lastname: field.text({
      validate: validate((value) => {
        validate.required(value, 'Last name');
        validate.minLength(value, 2);
        return value;
      }),
    }),
    country: field.select()({
      validate: validate((value) => {
        return value;
      }),
    }),
    phonenumber: field.text({
      validate: validate(validatePhoneNumber),
    }),
    password: field.text({
      validate: validate(validatePassword),
    }),
    confirmPassword: field.text({}),
    captchaToken: field.string({
      validate: validate((value) => {
        validate.required(value);
        return value;
      }),
    }),
  },
  {
    validate: {
      confirmPassword: validate.object((value, objectValue) => {
        if (objectValue.password !== value) {
          validate.error('Passwords do not match');
        }
        return value;
      }),
    },
  }
);
